module.exports = __webpack_public_path__ + "img/hr-white-desert-bush-13.18d51fa7.png";